import request from './request'

export function queryLogPageApi(params) {
  return request.get('/api/admin/query-logs', { params })
}
